function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1313"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1308"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 1049",
  fill: "none",
  d: "M0 0h101v101H0z"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1307"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1964",
  d: "M48 12h1.5a40.5 40.5 0 010 81h-1A40.5 40.5 0 018 52.5C8 30.132 25.632 12 48 12z",
  fill: "#e8f6f4"
}))));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon ionic-ios-card",
  fill: "#a1dbd3"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2030",
  d: "M69.501 41.557a2.888 2.888 0 00-2.88-2.88H32.067a2.888 2.888 0 00-2.88 2.88v4.319h40.314z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2031",
  d: "M29.187 64.593a2.888 2.888 0 002.88 2.88h34.554a2.888 2.888 0 002.88-2.88V50.195H29.187zm12.778-4.319h14.758a1.264 1.264 0 011.26 1.26 1.264 1.264 0 01-1.26 1.26H41.965a1.264 1.264 0 01-1.26-1.26 1.264 1.264 0 011.26-1.261zm-6.479 0h1.08a1.264 1.264 0 011.26 1.26 1.264 1.264 0 01-1.26 1.26h-1.08a1.264 1.264 0 01-1.26-1.26 1.264 1.264 0 011.26-1.261z"
}));
var SvgTpCard = function SvgTpCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101
  }, props), _ref, _ref2);
};
export default SvgTpCard;